import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { authAPI } from '../services/api';

const AccountSettings = () => {
  const user = authAPI.getCurrentUser();
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (form.newPassword !== form.confirmPassword) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      return;
    }
    if (form.newPassword.length < 6) {
      setError('Neues Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }

    setLoading(true);
    try {
      const res = await authAPI.changePassword(form.currentPassword, form.newPassword);
      setMessage(res.message || 'Passwort wurde geändert.');
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      setError(err.response?.data?.message || 'Passwort konnte nicht geändert werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <PageHeader
        kicker="Konto"
        title="Einstellungen"
        subtitle={user?.username ? `Angemeldet als ${user.username}` : undefined}
      />

      <div className="card-dark p-6 md:p-8">
        <h2 className="text-lg font-bold text-white mb-1">Passwort ändern</h2>
        <p className="text-white/50 text-sm mb-6">
          Gib dein aktuelles Passwort ein und wähle ein neues.
        </p>

        {message && (
          <div className="alert-success-dark mb-4" role="status">{message}</div>
        )}
        {error && (
          <div className="alert-error-dark mb-4" role="alert">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label-dark" htmlFor="currentPassword">Aktuelles Passwort</label>
            <input
              id="currentPassword"
              type="password"
              className="input-dark"
              autoComplete="current-password"
              required
              value={form.currentPassword}
              onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
            />
          </div>
          <div>
            <label className="label-dark" htmlFor="newPassword">Neues Passwort</label>
            <input
              id="newPassword"
              type="password"
              className="input-dark"
              autoComplete="new-password"
              required
              minLength={6}
              value={form.newPassword}
              onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
            />
          </div>
          <div>
            <label className="label-dark" htmlFor="confirmPassword">Neues Passwort bestätigen</label>
            <input
              id="confirmPassword"
              type="password"
              className="input-dark"
              autoComplete="new-password"
              required
              minLength={6}
              value={form.confirmPassword}
              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
            />
          </div>
          <button type="submit" className="btn-wacker w-full" disabled={loading}>
            {loading ? 'Speichern…' : 'Passwort speichern'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccountSettings;
